<p class="ellipsed"><span style="padding-right: 5px;" *ngIf="stamp.StampType == 8" translate="sagaMobile.mergedWith"></span>{{stamp.ActionText}}</p>
<p class="ellipsed">{{stamp.Text}}</p>